import { formatToDateInTz } from '@omecare/utils';
import { UserPlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import BookAgendaSlotAdmin from '@/components/forms/book-agenda-slot-admin/book-agenda-slot-admin-form';
import { Button } from '@/components/ui/button';
import { SlotSheetSection } from '../../slot-sheet/slot-sheet-section';
import { ViewAdminAgendaSlotSheetViewModel } from '../view-admin-agenda-slot-sheet.viewmodel';

/**
 * "Réserver le créneau" section: picks a substitute among those available, or
 * invites one by email.
 *
 * @param props.viewModel - the sheet view model
 * @returns the section element
 */
export const ViewAdminAgendaSlotSectionBooking = ({
  viewModel,
}: {
  viewModel: ViewAdminAgendaSlotSheetViewModel;
}) => {
  const { t } = useTranslation();

  return (
    <SlotSheetSection
      icon={UserPlusIcon}
      title={t('slot-sheet.section.booking')}
    >
      <div className="space-y-3">
        <BookAgendaSlotAdmin
          form={viewModel.bookSlot.data.form}
          slotType={viewModel.information.slotType}
          officeId={viewModel.officeId}
          date={formatToDateInTz({ date: viewModel.information.startAt })}
          period={viewModel.information.periodOfTheDay}
          onSelectAvailable={viewModel.bookSlot.api.confirmWithSubstitute}
          bookLoading={viewModel.bookSlot.data.loading}
        />

        <Button
          className="w-full"
          onClick={viewModel.bookSlot.api.confirm}
          loading={viewModel.bookSlot.data.loading}
        >
          {t('btn.book')}
        </Button>
      </div>
    </SlotSheetSection>
  );
};
